import fontGroups from '../../fontGroups';
import { fontGroupDeclarations, normalizedBaseUrl } from '../../utilities';
export default (function (path) {
  var baseUrl = normalizedBaseUrl(path);
  return fontGroupDeclarations(fontGroups.maven_pro, baseUrl);
});